export enum ModuleOperation {
    ARCHIVE_ACCESS = 'operation.module.archive.access',
    AUDIT_ACCESS = 'operation.module.audit.access',
    BILLING_ACCESS = 'operation.module.billing.access',
    CONTROL_PANEL_ACCESS = 'operation.module.control-panel.access',
    DIAGNOSE_ACCESS = 'operation.module.diagnose.access',
    GROSSING_ACCESS = 'operation.module.grossing.access',
    INCIDENT_ACCESS = 'operation.module.incident.access',
    INTEGRATION_ACCESS = 'operation.module.integration.access',
    LABORATORY_ACCESS = 'operation.module.laboratory.access',
    PETITIONER_ACCESS = 'operation.module.petitioner.access',
    REGISTRY_ACCESS = 'operation.module.registry.access',
    REPORTS_PANEL = 'operation.module.reports-panel.access',
    SCIENTIFIC_PANEL_ACCESS = 'operation.module.scientific-panel.access',
    SHIPMENTS_ACCESS = 'operation.module.shipment.access',
    STATISTICS_PANEL_ACCESS = 'operation.module.statistics-panel.access',
    WASTE_ACCESS = 'operation.module.waste.access',

    AUDIT = 'operation.module.audit',
    ARCHIVE = 'operation.module.archive',
    BILLING = 'operation.module.billing',
    CONFIGURATION = 'operation.module.configuration',
    CONTROL_PANEL = 'operation.module.control-panel',
    CORRELATION = 'operation.module.correlation',
    DASHBOARD = 'dashboard',
    DIAGNOSE = 'operation.module.diagnose',
    EXPENSE_AND_BILLING = 'operation.module.expenseandbilling',
    GROSSING = 'operation.module.grossing',
    INCIDENT = 'operation.module.incident',
    INTEGRATION = 'operation.module.integration',
    LABORATORY = 'operation.module.laboratory',
    MANUAL_SHIPMENT_RULES = 'operation.module.shipments.apply-manual-shipment-rules',
    PETITIONER = 'operation.module.petitioner',
    PRINT_CENTER = 'operation.module.printCenter',
    PRODUCTS_AND_STORAGE = 'operation.module.productsandstorage',
    REGISTRY = 'operation.module.registry',
    REGISTRY_REQUEST = 'operation.module.registry-request',
    SCIENTIFIC_PANEL = 'operation.module.scientific-panel',
    SHIPMENTS = 'operation.module.shipment',
    STATISTICS_PANEL = 'operation.module.statistics-panel',
    QUALITY = 'operation.module.quality',
    WASTE = 'operation.module.waste',

    CONFIGURATION_GLOBAL_ASSAYS = 'operation.module.configuration.global.assays',
    CONFIGURATION_GLOBAL_CASES = 'operation.module.configuration.global.cases',
    CONFIGURATION_GLOBAL_DEMOGRAPHY = 'operation.module.configuration.global.demography',
    CONFIGURATION_GLOBAL_INCIDENTS = 'operation.module.configuration.global.incidents',
    CONFIGURATION_GLOBAL_NOTIFICATIONS = 'operation.module.configuration.global.notification',
    CONFIGURATION_GLOBAL_PARAMETERS = 'operation.module.configuration.global.parameters',
    CONFIGURATION_GLOBAL_PERSONS = 'operation.module.configuration.global.persons',
    CONFIGURATION_GLOBAL_REQUESTER_STRUCTURE = 'operation.module.configuration.global.requester-structure',
    CONFIGURATION_GLOBAL_SAMPLES = 'operation.module.configuration.global.samples',
    CONFIGURATION_GLOBAL_SHIPMENTS = 'operation.module.configuration.global.shipments',

    CONFIGURATION_LOCAL_ASSAYS = 'operation.module.configuration.local.assays',
    CONFIGURATION_LOCAL_AUTOMATION = 'operation.module.configuration.local.automation',
    CONFIGURATION_LOCAL_CASES = 'operation.module.configuration.local.cases',
    CONFIGURATION_LOCAL_INCIDENTS = 'operation.module.configuration.local.incidents',
    CONFIGURATION_LOCAL_INFO_LABORATORY = 'operation.module.configuration.local.info-laboratory',
    CONFIGURATION_LOCAL_LABORATORY_PROCESSES = 'operation.module.configuration.local.laboratory-processes',
    CONFIGURATION_LOCAL_NOTICE_NOTIFICATION_ALARMS = 'operation.module.configuration.local.notice-notification-alarms',
    CONFIGURATION_LOCAL_PARAMETERS = 'operation.module.configuration.local.parameters',
    CONFIGURATION_LOCAL_PRINT = 'operation.module.configuration.local.print',
    CONFIGURATION_LOCAL_SAMPLES = 'operation.module.configuration.local.samples',
    CONFIGURATION_LOCAL_SHIPMENTS = 'operation.module.configuration.local.shipments',
    CONFIGURATION_LOCAL_TEMPLATE = 'operation.module.configuration.local.template',
    CONFIGURATION_LOCAL_VITROLINK = 'operation.module.configuration.local.vitrolink',
    CONFIGURATION_LOCAL_INSTRUMENT = 'operation.module.configuration.local.instrument'
}

export const MODULE_OPERATION_CONFIGURATION_PREFIX = 'operation.module.configuration'
export const MODULE_OPERATION_GLOBAL_CONFIGURATION_PREFIX = MODULE_OPERATION_CONFIGURATION_PREFIX + '.global'
export const MODULE_OPERATION_LOCAL_CONFIGURATION_PREFIX = MODULE_OPERATION_CONFIGURATION_PREFIX + '.local'
